import Select from '@atlaskit/select';

export * from '@atlaskit/select';

export default Select;
